/**
 * Tidy a link the way a club admin typed it.
 *
 * These fields used to be <input type="url">, which the browser marks invalid
 * for "www.foo.co.uk", the exact thing people type. It still saved, so the
 * only effect was a red field and a worried club secretary. Now the inputs are
 * plain text and we fix the value on blur instead of scolding them.
 *
 * Server-side `normalizePublicUrl` (lambda/lib/url.ts) is the authority; this
 * is purely so the operator SEES what will be stored.
 */
export function normalizeUrlInput(value: string): string {
  const s = value.trim();
  if (!s) return '';
  // Already carries a scheme, leave it; the server decides if it's allowed.
  if (/^[a-z][a-z0-9+.-]*:/i.test(s)) return s;
  return `https://${s.replace(/^\/+/, '')}`;
}
